import {
  RuntimeAction,
  SPI,
  ActionWidget,
  ActionWidgetProps,
  Widget,
  http,
  QueryPageResult,
  buildSingleItemParam,
  ModelFieldType
} from '@kunlun/dependencies';
import { DataOption } from './typing';
import Comp from './Transfer.vue';
import { nextTick } from 'vue';

@SPI.ClassFactory(ActionWidget.Token({ name: ['ActionTransfer', 'ActionTransfer_1', 'ActionTransfer_2'] }))
export class ActionTransfer extends ActionWidget {
  public initialize(props: ActionWidgetProps<RuntimeAction>) {
    super.initialize(props);
    this.setComponent(Comp);
    return this;
  }

  @Widget.Reactive()
  modalVisible = false;

  @Widget.Reactive()
  btnLoading = false;

  @Widget.Reactive()
  allData: any[] = [];

  @Widget.Reactive()
  selectedData: any[] = [];

  @Widget.Reactive()
  confirmLoading = false;

  originAllData: any[] = [];
  originSelectedData: any[] = [];

  @Widget.Reactive()
  private get fields(): DataOption[] {
    const mapping = (val): DataOption => {
      return {
        key: val.id,
        title: val.name,
        invisible: this.selectedData.every((i) => i.id !== val.id)
      };
    };
    return this.allData.map(mapping);
  }

  @Widget.Method()
  protected async clickAction(...args: unknown[]) {
    try {
      this.btnLoading = true;
      const res = await this.fetchAllData();
      const res1 = await this.fetchData(this.activeRecords?.map((i) => ({ id: i.id })));
      this.allData = res.content;
      this.selectedData = res1;

      this.originAllData = res.content;
      this.originSelectedData = res1;

      this.modalVisible = true;
    } finally {
      this.btnLoading = false;
    }
  }

  @Widget.Reactive()
  closeModal() {
    this.modalVisible = false;
  }

  @Widget.Reactive()
  async ok(dataSource: DataOption[], leftDataSource: DataOption[], rightDataSource: DataOption[]) {
    try {
      this.confirmLoading = true;
      await this.submitData(rightDataSource.map((i) => ({ id: i.key, name: i.title })));
      this.modalVisible = false;
      this.refreshCallChaining?.syncCall(true);
    } catch (error) {
      console.error(error);
    } finally {
      this.confirmLoading = false;
    }
  }

  @Widget.Reactive()
  reset() {
    this.allData = this.originAllData;
    this.selectedData = this.originSelectedData;
  }

  async fetchData(ids) {
    const { construct } = this.getAllConfig().context as any;

    const gql = `
      query {
        ${construct.query} {
          construct(data: {}, ${construct.in}: ${JSON.stringify(ids).replace(/"/g, '')}) {
            ${construct.out} {
              name
              id
            }
            idRequests {
              id
            }
          }
        }
      }
    `;

    const res = await http.query<Record<string, any>>(this.model.moduleName, gql);

    return res.data[construct.query].construct[construct.out] || [];
  }

  async fetchAllData() {
    const { queryPage } = this.getAllConfig().context as any;
    const gql = `
    query{
      ${queryPage.query} {
        queryPage(
          page: {currentPage: 1, size: 999}
          queryWrapper: {${queryPage.queryWrapper}}
        ) {
          content {
            name
            id
          }
          size
          totalPages
          totalElements
        }
      }
    }
    `;

    const res = await http.query<QueryPageResult<Record<string, any>>>(this.model.moduleName, gql);
    return res.data[queryPage.query].queryPage;
  }

  async submitData(records: any[]) {
    const fields = [
      {
        name: 'name',
        ttype: ModelFieldType.String
      },
      {
        name: 'id',
        ttype: ModelFieldType.String
      }
    ];
    // @ts-ignore
    const itemLabels = (await Promise.all(records.map(async (i) => await buildSingleItemParam(fields, i)))).reduce(
      (t, c) => t + c,
      ''
    );

    const { action } = this.getAllConfig().context as any;

    const gql = `
      mutation {
        ${action.mutation} {
          ${action.funName}(
            data: {
              ${action.in}: [${itemLabels}]
              idRequests: ${JSON.stringify(this.activeRecords!.map((i) => ({ id: i.id }))).replace(/"/g, '')}
            }
          ) {
            success
          }
        }
      }
    `;

    await http.mutate(this.model.moduleName, gql);
  }
}
